import React from 'react';
import { Button, Table, Icon } from 'semantic-ui-react';
import 'semantic-ui-css/components/table.min.css';
import { Link, Redirect } from 'react-router-dom';
import MyList from './list';

interface ListProps {

}

interface ListState {
    data: any[],
    errorMsg: string
}

class SettingsList extends MyList {
    entity = "settings"

    render() {
        if (this.state.redirect) {
            return <Redirect to={this.state.redirect}/>
        }
        return (
            <section className="full-width">
                <h2>Веб сайтын тохиргоо</h2>

                <Table striped className="admin-list-table" width={16}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>№</Table.HeaderCell>
                            <Table.HeaderCell>Нэр</Table.HeaderCell>
                            <Table.HeaderCell>Утга</Table.HeaderCell>
                            <Table.HeaderCell>Тайлбар</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        { this.state?.data?.map((row: any, index: number) => {
                                return <Table.Row key={row.id}>
                                    <Table.Cell data-label="№">{ String(index+1) }</Table.Cell>
                                    <Table.Cell data-label="Нэр">
                                        <strong>
                                            <Link className="underline hover-blue" to={"/mongol/settings/" + row.id}>{ row.key }</Link>
                                        </strong>
                                    </Table.Cell>
                                    <Table.Cell data-label="Утга">{ row.value }</Table.Cell>
                                    <Table.Cell data-label="Тайлбар">{ row.info }</Table.Cell>
                                </Table.Row>
                            })
                        }
                    </Table.Body>
                </Table>
            </section>
        );
    }
}
            
export default SettingsList;